import { cloneDeep } from 'lodash'
import { DataItem } from 'scrivito'

import { AddressType } from './types'
import { SchemaAttributes } from '@/Data/types'
import { getDisplayValue } from '@/utils/getDisplayValue'
import { isString } from '@/utils/isString'

export const formatAddressSubtitle = (
  address: DataItem,
  addressSchema?: DataItem,
) => {
  const street = address.get('street')
  const postalCode = address.get('postalCode')
  const poBox = address.get('poBox')
  const poBoxPostalCode = address.get('poBoxPostalCode')
  const city = address.get('city')
  const country = address.get('country')

  const parts: string[] = []

  if (isString(street)) parts.push(street)
  if (isString(poBox)) parts.push(poBox)

  if (isString(postalCode)) parts.push(postalCode)
  if (isString(poBoxPostalCode)) parts.push(poBoxPostalCode)

  if (isString(city)) parts.push(city)
  if (isString(country)) {
    parts.push(
      addressSchema
        ? getDisplayValue({
            rawValue: country,
            key: 'country',
            schema: addressSchema,
          })
        : country,
    )
  }

  return parts.join(', ')
}

export const getFixedAddressAttributes = (
  type?: AddressType,
  includeType = false,
) => {
  const base = ['city', 'country']

  const attrs =
    type === 'CORRESPONDENCE'
      ? ['poBox', 'poBoxPostalCode', ...base]
      : ['street', 'postalCode', ...base]

  return includeType ? ['type', ...attrs] : attrs
}

export const getAvailableAddressesSchemaAttributes = (
  schemaAttributes?: SchemaAttributes,
  availableTypes?: AddressType[],
): SchemaAttributes | undefined => {
  if (!schemaAttributes) {
    return schemaAttributes
  }
  const filteredSchemaAttributes = cloneDeep(schemaAttributes)

  if (
    !filteredSchemaAttributes.type ||
    !filteredSchemaAttributes.type.enumValues
  ) {
    return filteredSchemaAttributes
  }
  try {
    filteredSchemaAttributes.type.enumValues =
      filteredSchemaAttributes.type.enumValues.filter((opt) =>
        availableTypes?.includes(opt.value as AddressType),
      )
  } catch (error) {
    reportError(error)
  }
  return filteredSchemaAttributes
}
